@let talkTime = talkTime$ | async;
@let meta = $any(call);

<div class="call-card"
     [class.call-card--ringing]="call.status === CallingState.WaitingForAnAnswer"
     [class.call-card--talking]="call.status === CallingState.Answered && !call.isHold"
     [class.call-card--hold]="call.isHold"
     (click)="isShowDetail = !isShowDetail">

  <div class="call-card__stripe"></div>

  <div class="call-card__body">

    <!-- Avatar / pulse ring -->
    <div class="call-avatar" [class.call-avatar--pulse]="call.status === CallingState.WaitingForAnAnswer">
      <ion-icon name="person-circle-outline" class="call-avatar__icon"></ion-icon>
    </div>

    <!-- Info -->
    <div class="call-info">
      @if (callerName) {
        <p class="call-info__name">{{ callerName }}</p>
      }
      <p class="call-info__phone">{{ call.phone }}</p>
      <p class="call-info__status"
         [class.call-info__status--ringing]="call.status === CallingState.WaitingForAnAnswer"
         [class.call-info__status--talking]="call.status === CallingState.Answered && !call.isHold"
         [class.call-info__status--hold]="call.isHold">
        @if (call.status === CallingState.Answered && !call.isHold) {
          На зв'язку &nbsp;{{ talkTime }}
        } @else if (call.isHold) {
          Утримання
        } @else {
          Вхідний дзвінок...
        }
      </p>
    </div>

    <!-- Actions -->
    <div class="call-actions" (click)="$event.stopPropagation()">
      @if (canAnswer) {
        <button class="call-btn-answer" (click)="answer()">
          <ion-icon name="call-sharp"></ion-icon>
        </button>
      } @else {
        <div class="call-talking-indicator">
          <ion-icon name="call-outline"></ion-icon>
        </div>
      }
      @if (canStartTransfer) {
        <button class="call-btn-order" aria-label="Переадресувати" (click)="openTransfer()">
          <ion-icon name="arrow-redo-outline"></ion-icon>
        </button>
        <button class="call-btn-order" aria-label="Запросити колегу" (click)="openInvite()">
          <ion-icon name="people-outline"></ion-icon>
        </button>
      }
      @if (canEndConference) {
        <button class="call-btn-order call-btn-order--danger" aria-label="Скасувати конференцію" (click)="endConference()">
          <ion-icon name="close-circle-outline"></ion-icon>
        </button>
      } @else if (canJoinConference) {
        <button class="call-btn-order" aria-label="Конференція" (click)="joinConference()">
          <ion-icon name="people-circle-outline"></ion-icon>
        </button>
      }
      <button class="call-btn-order" (click)="openCreateOrder()">
        <ion-icon name="add-outline"></ion-icon>
      </button>
    </div>

  </div>

  <!-- Consult transfer in progress -->
  @if (call.transfer; as tr) {
    <div class="call-xfer" (click)="$event.stopPropagation()">
      <p class="call-xfer__info">
        Клієнт на утриманні · {{ tr.status === 'talking' ? 'на зв’язку з' : 'дзвонимо' }}
        <b>{{ tr.toName || tr.to }}</b>
      </p>
      @if (isTransferOwner) {
        <div class="call-xfer__actions">
          <ion-button size="small" [disabled]="!!tr.mode && tr.status !== 'talking'" (click)="completeTransfer()">
            {{ CONSULT_CONFIRM_LABELS[tr.mode || 'transfer'] }}
          </ion-button>
          <ion-button size="small" fill="outline" color="medium" (click)="cancelTransfer()">Скасувати</ion-button>
        </div>
      }
    </div>
  }

  <!-- Expanded doc details -->
  @if (isShowDetail) {
    <div class="call-card__details">

      @if (meta?.typeOfDoc) {
        <div class="call-detail-row">
          <span class="call-detail-row__label">{{ DocTypeRelationName[meta.typeOfDoc] }}</span>
          <span class="call-detail-row__value">
            №{{ meta.numberOfDoc }} від {{ meta.docCreatedAt | date: 'dd.MM.yyyy HH:mm' }}
          </span>
        </div>
        <div class="call-detail-row">
          <span class="call-doc-status" [ngClass]="meta.statusOfDoc?.status">
            {{ docStatus[meta.statusOfDoc?.status] }}
          </span>
        </div>
      }

      @if (meta?.street) {
        <div class="call-detail-row call-detail-row--address">
          <ion-icon name="location-outline" class="call-detail-row__icon"></ion-icon>
          <span>{{ meta.street }}{{ meta.city ? ', ' + meta.city : '' }}{{ meta.country ? ', ' + meta.country : '' }}</span>
        </div>
      }

      @if (!meta?.typeOfDoc && !meta?.street) {
        <p class="call-detail-empty">Немає даних про клієнта</p>
      }

    </div>
  }

</div>
